'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = basket;

var _constants = require('redux/constants');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    items: [],
    dataError: [],
    preload: false,
    is_coped_items: false,
    isServerLoad: false,
    sharePreload: false,
    actualPricesPreload: false,
    shareCode: '',
    showShare: false
};

function basket() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var arrayItems = [];

    switch (action.type) {
        case _constants.BasketConstants.ADD_BASKET:
            var items = state.items.slice(),
                flagPush = true;
            if (action.product.type_id !== 5 && action.product.basket_number === undefined && action.product.custom_fields == null) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].id === action.product.id && items[i].modifier_option_id === action.product.modifier_option_id) {
                        items[i].count += action.product.count;
                        flagPush = false;
                        break;
                    }
                }
            } else if (action.product.basket_number !== undefined) {
                flagPush = true;
            } else if (action.product.custom_fields != null && action.product.custom_fields.length > 0) {
                flagPush = true;
            } else {
                var key = null;
                for (var _i = 0; _i < items.length; _i++) {
                    if (items[_i].id === action.product.id && items[_i].modifier_option_name === action.product.modifier_option_name) {
                        key = _i;
                        for (var j = 0; j < items[_i].nested_offer.length; j++) {
                            if (items[_i].nested_offer[j].childOffer.type_id === 5) {
                                for (var k = 0; k < items[_i].nested_offer[j].childOffer.nestedOffers.length; k++) {
                                    if (items[_i].nested_offer[j].childOffer.nestedOffers[k].quantity !== action.product.nested_offer[j].childOffer.nestedOffers[k].quantity) {
                                        key = null;
                                    }
                                }
                                if (items[_i].nested_offer[j].modifierName !== action.product.nested_offer[j].modifierName) {
                                    key = null;
                                }
                            } else if (items[_i].nested_offer[j].quantity !== action.product.nested_offer[j].quantity) {
                                key = null;
                            }
                        }
                        if (key !== null) {
                            items[_i].count += action.product.count;
                            flagPush = false;
                            break;
                        }
                    }
                }
            }

            flagPush == true && items.push(action.product);

            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(items));

            return (0, _extends3.default)({}, state, {
                shareCode: '',
                showShare: false,
                items: items
            });

        case _constants.BasketConstants.REMOVE_BASKET:
            var itemsArray = null;
            if (action.keyArray !== null && state.items[action.keyArray].id === action.id && state.items[action.keyArray].modifier_option_id === action.modifier_option_id) {
                itemsArray = state.items.filter(function (item, key) {
                    if (key === action.keyArray) {
                        return false;
                    }
                    return true;
                });
            } else {
                itemsArray = state.items.filter(function (item) {
                    if (item.id && item.id === action.id && item.modifier_option_id === action.modifier_option_id) {
                        return false;
                    }
                    return true;
                });
            }

            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(itemsArray));

            return (0, _extends3.default)({}, state, {
                shareCode: '',
                showShare: false,
                items: itemsArray,
                dataError: []
            });

        case _constants.BasketConstants.CHANGE_COUNT_PRODUCT_IN_BASKET:
            var changeCountArray = null;
            if (action.keyArray !== null && state.items[action.keyArray].id === action.id && state.items[action.keyArray].modifier_option_id === action.modifier_option_id) {
                changeCountArray = state.items.map(function (item, key) {
                    if (key === action.keyArray) {
                        item.count = action.count;
                    }
                    return item;
                });
            } else {
                changeCountArray = state.items.map(function (item) {
                    if (item.id && item.id === action.id && item.modifier_option_id === action.modifier_option_id) {
                        item.count = action.count;
                    }
                    return item;
                });
            }
            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(changeCountArray));

            return (0, _extends3.default)({}, state, {
                items: changeCountArray,
                shareCode: '',
                showShare: false
            });

        case _constants.BasketConstants.COPY_TO_BASKET:

            if (!state.serverLoad) {

                var itemsCopy = void 0;

                try {
                    itemsCopy = JSON.parse(_LocalStorageProxy2.default.getItem('basket.common'));
                } catch (e) {
                    itemsCopy = null;
                }

                if (!Array.isArray(itemsCopy)) {
                    itemsCopy = [];
                }

                return (0, _extends3.default)({}, state, {
                    is_coped_items: true,
                    items: itemsCopy
                });
            } else {
                _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(state.items));
                return (0, _extends3.default)({}, state, {
                    is_coped_items: true
                });
            }

        case _constants.BasketConstants.CLEAR_BASKET:

            _LocalStorageProxy2.default.setItem('basket.common', []);

            return (0, _extends3.default)({}, state, {
                items: [],
                shareCode: ''
            });

        case _constants.BasketConstants.ORDER_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });

        case _constants.BasketConstants.ORDER_LOAD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                dataError: []
            });

        case _constants.BasketConstants.ORDER_LOAD_FAIL:
            var dataError = action.error.dataError || [];
            return (0, _extends3.default)({}, state, {
                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
                preload: false
            });

        case _constants.BasketConstants.SHARE_BASKET_LOAD:
            return (0, _extends3.default)({}, state, {
                sharePreload: true
            });

        case _constants.BasketConstants.SHARE_BASKET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                sharePreload: false,
                showShare: true,
                shareCode: action.result
            });

        case _constants.BasketConstants.SHARE_BASKET_FAIL:
            return (0, _extends3.default)({}, state, {
                sharePreload: false
            });

        case _constants.BasketConstants.GET_SHARE_BASKET_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });

        case _constants.BasketConstants.GET_SHARE_BASKET_SUCCESS:
            // arrayItems = action.result.cartItems.map((item)=>{
            //     return {
            //         ...item.offer,
            //         picture: item.offer.pictures[0] || null,
            //         count: item.count
            //     }
            // });
            arrayItems = action.result.products;

            return (0, _extends3.default)({}, state, {
                preload: false,
                serverLoad: true,
                items: arrayItems,
                fields: action.result.fields
            });

        case _constants.BasketConstants.GET_SHARE_BASKET_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false
            });

        case _constants.BasketConstants.BASKET_CHANGE_SHARE:
            return (0, _extends3.default)({}, state, {
                showShare: action.payload
            });

        case _constants.BasketConstants.GET_ACTUAL_PRICES_LOAD:
            return (0, _extends3.default)({}, state, {
                actualPricesPreload: true
            });

        case _constants.BasketConstants.GET_ACTUAL_PRICES_SUCCESS:
            return (0, _extends3.default)({}, state, {
                actualPricesPreload: false,
                serverLoad: true,
                items: action.result
            });

        case _constants.BasketConstants.GET_ACTUAL_PRICES_FAIL:
            return (0, _extends3.default)({}, state, {
                actualPricesPreload: false
            });

        case _constants.BasketConstants.ADD_COUPON_IN_BASKET:
            var basketItems = state.items.filter(function (item) {
                if (item.is_coupon !== undefined) {
                    return false;
                }
                return true;
            });

            basketItems.push(action.product);

            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(basketItems));

            return (0, _extends3.default)({}, state, {
                shareCode: '',
                showShare: false,
                items: basketItems
            });

        case _constants.BasketConstants.POSTPONE_BASKET_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.BasketConstants.POSTPONE_BASKET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                dataError: []
            });
        case _constants.BasketConstants.POSTPONE_BASKET_FAIL:
            var dataError = action.error.dataError || [];
            return (0, _extends3.default)({}, state, {
                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
                preload: false
            });

        case _constants.BasketConstants.GET_POSTPONE_BASKET_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.BasketConstants.GET_POSTPONE_BASKET_SUCCESS:
            // console.log(action.result);
            return (0, _extends3.default)({}, state, {
                preload: false,
                dataError: [],
                itemsPostpone: action.result
            });

        case _constants.BasketConstants.GET_POSTPONE_BASKET_FAIL:
            var dataError = action.error.dataError || [];
            return (0, _extends3.default)({}, state, {
                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
                preload: false
            });

        case _constants.BasketConstants.DELETE_POSTPONE_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.BasketConstants.DELETE_POSTPONE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                dataError: [],
                itemsPostpone: action.result
            });

        case _constants.BasketConstants.DELETE_POSTPONE_FAIL:
            var dataError = action.error.dataError || [];
            return (0, _extends3.default)({}, state, {
                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
                preload: false
            });
        case _constants.BasketConstants.MERGE_POSTPONE_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.BasketConstants.MERGE_POSTPONE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                dataError: [],
                itemsPostpone: action.result
            });

        case _constants.BasketConstants.MERGE_POSTPONE_FAIL:
            var dataError = action.error.dataError || [];
            return (0, _extends3.default)({}, state, {
                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
                preload: false
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/basket.js
// module id = 1896
// module chunks = 0